import { useEffect, useState } from "react";
import { getClientConfig } from "../utils/keyVault.js";

export function useClientConfig() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function loadConfig() {
      try {
        const nextConfig = await getClientConfig();
        if (isMounted) {
          setConfig(nextConfig);
        }
      } catch (error) {
        console.error("Failed to load API credentials", error);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    loadConfig();

    return () => {
      isMounted = false;
    };
  }, []);

  return { config, loading };
}
